import React from 'react'

interface IProps {
    className?: string
    children?: any
}

const TableLayout: React.FC<IProps> = ({className, children}) => {
    return (
        <div className={`mt-[20px] bg-white rounded-[10px] overflow-hidden shadow-normal ${className}`}>{children}</div>
    )
}

export default TableLayout
